import { TimeUnitApi } from 'api-typings/common/common';
import {
  DowngradeApi,
  DurationApi,
} from 'api-typings/memberships/memberships_types';
import { Duration } from '../membership-subscriptions';
import { MembershipDowngrade } from './membership-downgrades.model';

export function transformMembershipDowngrades(
  membershipDowngrades: DowngradeApi,
): MembershipDowngrade {
  return {
    id: membershipDowngrades.id,
    timeCreated: membershipDowngrades.time_created * 1000,
    status: membershipDowngrades.status,
    packageId: membershipDowngrades.package_id,
    duration: transformDuration(membershipDowngrades.duration),
    failureCount: membershipDowngrades.failure_count,
    autoRenew: membershipDowngrades.auto_renew,
    periodId: membershipDowngrades.period_id,
    quantity: membershipDowngrades.quantity,
    isTrial: membershipDowngrades.is_trial || false,
  };
}

function transformDuration(duration: DurationApi): Duration {
  return {
    id: duration.id,
    type: duration.type || TimeUnitApi.MONTH,
    cycle: duration.cycle || 1,
  };
}
